import dataProvider from 'dataProvider';

import { SparePart, buildSkuReference } from 'types/spare-part';

export const generateUniqueI = async (sparePart: SparePart): Promise<string> => {
  const sku_reference = buildSkuReference(sparePart);
  return dataProvider
    .getList('spare-parts', {
      pagination: { page: 1, perPage: 10 },
      sort: { field: 'id', order: 'DESC' },
      filter: { q: sparePart.reference },
    })
    .then(({ data: skuList }: { data: SparePart[] }) => {
      const existingSkuId =
        skuList.find((element) => element.unique_id === sku_reference + '/' + sparePart.id)?.id ??
        -1;
      if (existingSkuId === -1) {
        return sku_reference + '/' + sparePart.id;
      }
      if (existingSkuId === sparePart.id) return sku_reference + '/' + sparePart.id;
      return sku_reference + '/' + sparePart.id + 'x';
    });
};
